import React from 'react';
import BaseTooltip from 'react-tooltip-lite';
import styled from 'styled-components';

const Tooltip = styled(BaseTooltip)`
  span:nth-child(1) {
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 2px 1px;
    border-radius: 4px;
  }

  span:nth-child(2) {
    border-color: lightgrey;
  }
`;

export default Tooltip;
